export default function StatCard({ testid, icon: Icon, label, value, highlight = false, accent = "gold" }) {
  const accentColor = accent === "red" ? "#b22234" : "#ffd700";
  return (
    <div
      data-testid={testid}
      className={
        "relative p-6 border " +
        (highlight
          ? "bg-[#0a1628] shadow-[0_0_40px_rgba(255,215,0,0.15)]"
          : "bg-[#0a1628]")
      }
      style={{ borderColor: highlight ? accentColor : "rgba(255,215,0,0.3)" }}
    >
      <div className="flex items-center justify-between">
        <span className="font-accent text-[10px] tracking-[0.3em] text-white/60">
          {label}
        </span>
        {Icon && <Icon size={16} style={{ color: accentColor }} />}
      </div>
      <div
        className={
          "mt-3 font-display font-black text-4xl " +
          (highlight ? "gold-text" : "text-white")
        }
      >
        {value}
      </div>
    </div>
  );
}
